import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70f0fb66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contact_form_input = _resolveComponent("contact-form-input")!
  const _component_contact_form_check = _resolveComponent("contact-form-check")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_contact_form_input, { onForwardToCheck: _ctx.onForwardToCheck }, null, 8, ["onForwardToCheck"]), [
      [_vShow, _ctx.formStep === 1]
    ]),
    _withDirectives(_createVNode(_component_contact_form_check, {
      "form-data": _ctx.formData,
      "error-message": _ctx.errorMessage,
      onCheckOut: _ctx.onCheckout,
      onBackToInput: _ctx.onBackToInput
    }, null, 8, ["form-data", "error-message", "onCheckOut", "onBackToInput"]), [
      [_vShow, _ctx.formStep === 2]
    ])
  ]))
}